import { useState } from "react";
import DeliveryAndReturns from "../../components/deliveryAndReturns/DeliveryAndReturns";
import ShippingRestrictionsModal from "../../components/shippingRestrictionsModal/ShippingRestrictionsModal";
import { useProduct } from "../../context/product/ProductContext";

export default function DeliveryAndReturnsContainer() {
  const { product } = useProduct();
  const [
    shippingRestrictionsIncludedCountries,
    setShippingRestrictionsIncludedCountries,
  ] = useState([]);
  const [openShippingRestrictions, setOpenShippingRestrictions] =
    useState(false);
  const [
    shippingRestrictionsModalFocusOnClose,
    setShippingRestrictionsModalFocusOnClose,
  ] = useState(null);

  if (!product || product.isInStock === false) {
    return null;
  }

  const toggleShippingRestrictions = (
    openShippingRestrictions,
    shippingRestrictionsIncludedCountries,
    shippingRestrictionsModalFocusOnClose
  ) => {
    setOpenShippingRestrictions(openShippingRestrictions);

    setShippingRestrictionsIncludedCountries(
      shippingRestrictionsIncludedCountries ?? []
    );

    shippingRestrictionsModalFocusOnClose &&
      setShippingRestrictionsModalFocusOnClose(
        shippingRestrictionsModalFocusOnClose
      );
  };

  return (
    <>
      <DeliveryAndReturns
        toggleShippingRestrictions={toggleShippingRestrictions}
      />
      <ShippingRestrictionsModal
        includedCountries={shippingRestrictionsIncludedCountries}
        open={openShippingRestrictions}
        focusOnClose={shippingRestrictionsModalFocusOnClose}
        toggleShippingRestrictions={toggleShippingRestrictions}
      />
    </>
  );
}
